(function () {
  window.lumenearzLanding1Loaded = (window.lumenearzLanding1Loaded || 0) + 1;
  let initAttempts = 0;
  const bundleAutoShuffleEnabled = false;
  const bundleAutoShuffleDelay = 2000;
  const reducedMotionQuery = window.matchMedia ? window.matchMedia('(prefers-reduced-motion: reduce)') : null;

  const getCartTarget = () => document.querySelector('cart-drawer') || document.querySelector('cart-notification');

  const getCartAddUrl = () => {
    const cartAddUrl = window.routes && window.routes.cart_add_url ? window.routes.cart_add_url : '/cart/add';

    return cartAddUrl.endsWith('.js') ? cartAddUrl : `${cartAddUrl}.js`;
  };

  const getCartUrl = () => (window.routes && window.routes.cart_url ? window.routes.cart_url : '/cart');

  const getGroupElements = (root, selector, group) =>
    Array.from(root.querySelectorAll(selector)).filter((element) => element.dataset.bundleGroup === group);

  const getLandingRoot = (root) => root.closest('.lumenearz-landing-1') || document;

  const getStickyCta = (root) => getLandingRoot(root).querySelector('[data-landing-1-sticky]');

  const getSubmitButtons = (root) =>
    [
      root.querySelector('[data-landing-1-bundle-submit]'),
      getStickyCta(root) ? getStickyCta(root).querySelector('[data-landing-1-sticky-submit]') : null,
    ].filter(Boolean);

  const setBundleLoading = (root, isLoading) => {
    getSubmitButtons(root).forEach((button) => {
      button.classList.toggle('is-loading', isLoading);
      button.disabled = isLoading;
      button.setAttribute('aria-disabled', String(isLoading));
    });
  };

  const fitStickyPrice = (sticky) => {
    const priceWrap = sticky ? sticky.querySelector('.lx-landing-1-sticky-cta__price-wrap') : null;
    const price = sticky ? sticky.querySelector('.lx-landing-1-sticky-cta__price') : null;

    if (!priceWrap || !price) return;

    priceWrap.style.setProperty('--lx-landing-1-sticky-price-scale', '1');

    const availableWidth = priceWrap.clientWidth;
    const naturalWidth = price.scrollWidth;
    const scale = naturalWidth > 0 && availableWidth > 0 ? Math.min(1, availableWidth / naturalWidth) : 1;
    const boundedScale = Math.max(0.42, scale);

    priceWrap.style.setProperty('--lx-landing-1-sticky-price-scale', boundedScale.toFixed(3));
    sticky.classList.toggle('is-price-compressed', boundedScale < 0.985);
  };

  const updateStickyCta = (root, activeItem, isAvailable) => {
    const sticky = getStickyCta(root);

    if (!sticky) return;

    const priceDisplay = activeItem && activeItem.dataset.bundlePriceDisplay
      ? activeItem.dataset.bundlePriceDisplay
      : sticky.dataset.initialPriceDisplay || root.dataset.initialPriceDisplay || '';
    const submit = sticky.querySelector('[data-landing-1-sticky-submit]');
    const submitText = sticky.querySelector('[data-landing-1-sticky-submit-text]');
    const addLabel = root.dataset.stickyAddLabel || sticky.dataset.stickyLabel || 'Grab this Bundle';
    const unavailableLabel = root.dataset.unavailableLabel || 'Unavailable';
    const soldOutLabel = root.dataset.soldOutLabel || 'Sold out';

    sticky.querySelectorAll('[data-landing-1-sticky-price]').forEach((priceElement) => {
      priceElement.textContent = priceDisplay;
    });
    fitStickyPrice(sticky);
    window.requestAnimationFrame(() => fitStickyPrice(sticky));

    if (submit) {
      submit.disabled = !isAvailable;
      submit.setAttribute('aria-disabled', String(!isAvailable));
    }

    if (submitText) {
      submitText.textContent = isAvailable ? addLabel : activeItem && activeItem.dataset.variantId ? soldOutLabel : unavailableLabel;
    }
  };

  const updateBundleSubmit = (root, activeItem) => {
    const submitText = root.querySelector('[data-landing-1-bundle-submit-text]');
    const selectedText = root.querySelector('[data-landing-1-bundle-selected]');
    const addLabel = root.dataset.addLabel || 'Free Priority Shipping Bundle';
    const unavailableLabel = root.dataset.unavailableLabel || 'Unavailable';
    const soldOutLabel = root.dataset.soldOutLabel || 'Sold out';
    const baseAvailable = root.dataset.baseAvailable === 'true' && root.dataset.baseVariantId;
    const itemAvailable = activeItem && activeItem.dataset.productAvailable === 'true' && activeItem.dataset.variantId;
    const isAvailable = Boolean(baseAvailable && itemAvailable);

    getSubmitButtons(root).forEach((submit) => {
      submit.disabled = !isAvailable;
      submit.setAttribute('aria-disabled', String(!isAvailable));
    });

    if (submitText) {
      submitText.textContent = isAvailable ? addLabel : activeItem && activeItem.dataset.variantId ? soldOutLabel : unavailableLabel;
    }

    if (selectedText && activeItem) {
      selectedText.textContent = `Selected bundle item: ${activeItem.dataset.productTitle || 'Bundle item'}`;
    }

    updateStickyCta(root, activeItem, isAvailable);
  };

  const selectBundleItem = (root, group, index) => {
    const targetIndex = String(index || '0');
    const mediaItems = Array.from(root.querySelectorAll('[data-landing-1-bundle-media]'));
    const selectors = Array.from(root.querySelectorAll('[data-landing-1-bundle-item]'));
    let activeItem = null;

    mediaItems.forEach((media) => {
      const isActive = media.dataset.bundleGroup === group && media.dataset.bundleIndex === targetIndex;

      media.hidden = !isActive;
      media.classList.toggle('is-active', isActive);
    });

    selectors.forEach((selector) => {
      if (selector.dataset.bundleGroup !== group) return;

      const isActive = selector.dataset.bundleIndex === targetIndex;

      selector.classList.toggle('is-active', isActive);
      selector.setAttribute('aria-pressed', String(isActive));
      selector.setAttribute('aria-checked', String(isActive));

      if (isActive) activeItem = selector;
    });

    updateBundleSubmit(root, activeItem);
  };

  const setBundleGroup = (root, group) => {
    const nextGroup = group === 'accessories' ? 'accessories' : 'shades';
    const panels = Array.from(root.querySelectorAll('[data-landing-1-bundle-selector-panel]'));
    const groupButtons = Array.from(root.querySelectorAll('[data-landing-1-bundle-group]'));
    const activeSelector =
      getGroupElements(root, '[data-landing-1-bundle-item]', nextGroup).find((selector) =>
        selector.classList.contains('is-active')
      ) || getGroupElements(root, '[data-landing-1-bundle-item]', nextGroup)[0];

    root.dataset.activeGroup = nextGroup;

    panels.forEach((panel) => {
      const isActive = panel.dataset.bundleGroup === nextGroup;

      panel.hidden = !isActive;
      panel.classList.toggle('is-active', isActive);
    });

    groupButtons.forEach((button) => {
      const isActive = button.dataset.bundleGroup === nextGroup;

      button.classList.toggle('is-active', isActive);
      button.setAttribute('aria-pressed', String(isActive));
    });

    if (activeSelector) {
      selectBundleItem(root, nextGroup, activeSelector.dataset.bundleIndex);
    } else {
      updateBundleSubmit(root, null);
    }
  };

  const getBundleGroups = (root) => {
    const groups = Array.from(root.querySelectorAll('[data-landing-1-bundle-group]'))
      .map((button) => button.dataset.bundleGroup)
      .filter(Boolean);

    return groups.length ? groups : ['shades', 'accessories'];
  };

  const getBundleGroupDirection = (root, targetGroup) => {
    const groups = getBundleGroups(root);
    const activeGroup = root.dataset.activeGroup || groups[0];
    const activeIndex = groups.indexOf(activeGroup);
    const targetIndex = groups.indexOf(targetGroup);

    if (activeIndex === -1 || targetIndex === -1) return 'next';

    return targetIndex >= activeIndex ? 'next' : 'previous';
  };

  const getAdjacentBundleGroup = (root, direction) => {
    const groups = getBundleGroups(root);
    const activeGroup = root.dataset.activeGroup || groups[0];
    const activeIndex = Math.max(0, groups.indexOf(activeGroup));
    const nextIndex =
      direction === 'previous'
        ? (activeIndex - 1 + groups.length) % groups.length
        : (activeIndex + 1) % groups.length;

    return groups[nextIndex];
  };

  const setBundleGroupWithMotion = (root, group, direction) => {
    const nextGroup = group === 'accessories' ? 'accessories' : 'shades';
    const currentGroup = root.dataset.activeGroup || 'shades';

    if (nextGroup === currentGroup) {
      setBundleGroup(root, nextGroup);
      return;
    }

    window.clearTimeout(root.landing1BundleMotionTimer);
    root.dataset.slideDirection = direction === 'previous' ? 'previous' : 'next';
    root.classList.remove('is-sliding');
    void root.offsetWidth;
    root.classList.add('is-sliding');

    setBundleGroup(root, nextGroup);

    root.landing1BundleMotionTimer = window.setTimeout(() => {
      root.classList.remove('is-sliding');
      delete root.dataset.slideDirection;
    }, 280);
  };

  const canAutoShuffleBundle = (root) =>
    bundleAutoShuffleEnabled && getBundleGroups(root).length > 1 && !(reducedMotionQuery && reducedMotionQuery.matches);

  const stopBundleAutoShuffle = (root) => {
    window.clearTimeout(root.landing1BundleAutoShuffleTimer);
    root.landing1BundleAutoShuffleTimer = null;
  };

  const scheduleBundleAutoShuffle = (root) => {
    stopBundleAutoShuffle(root);

    if (!canAutoShuffleBundle(root)) return;

    root.landing1BundleAutoShuffleTimer = window.setTimeout(() => {
      if (!document.documentElement.contains(root)) return;

      const isLoading = getSubmitButtons(root).some((button) => button.classList.contains('is-loading'));

      if (document.visibilityState === 'hidden' || isLoading) {
        scheduleBundleAutoShuffle(root);
        return;
      }

      setBundleGroupWithMotion(root, getAdjacentBundleGroup(root, 'next'), 'next');
      scheduleBundleAutoShuffle(root);
    }, bundleAutoShuffleDelay);
  };

  const consumeSuppressedClick = (root) => {
    if (root.dataset.landing1BundleSuppressClick !== 'true') return false;

    delete root.dataset.landing1BundleSuppressClick;
    return true;
  };

  const activateBundleItem = (root, itemButton) => {
    if (!itemButton) return;

    const group = itemButton.dataset.bundleGroup;

    setBundleGroup(root, group);
    selectBundleItem(root, group, itemButton.dataset.bundleIndex);
  };

  const bindBundleSwipe = (root) => {
    const swipeTarget = root.querySelector('[data-landing-1-bundle-swipe]');

    if (!swipeTarget) return;

    let pointerId = null;
    let startX = 0;
    let startY = 0;
    let hasSwiped = false;

    const clearSwipe = () => {
      pointerId = null;
      startX = 0;
      startY = 0;
      hasSwiped = false;
    };

    swipeTarget.addEventListener('pointerdown', (event) => {
      if (event.pointerType === 'mouse' && event.button !== 0) return;

      pointerId = event.pointerId;
      startX = event.clientX;
      startY = event.clientY;
      hasSwiped = false;

      if (typeof swipeTarget.setPointerCapture === 'function') {
        swipeTarget.setPointerCapture(pointerId);
      }
    });

    swipeTarget.addEventListener('pointermove', (event) => {
      if (pointerId !== event.pointerId) return;

      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;

      if (Math.abs(deltaX) > 16 && Math.abs(deltaX) > Math.abs(deltaY)) {
        hasSwiped = true;
        event.preventDefault();
      }
    });

    swipeTarget.addEventListener('pointerup', (event) => {
      if (pointerId !== event.pointerId) {
        clearSwipe();
        return;
      }

      const deltaX = event.clientX - startX;
      const deltaY = event.clientY - startY;
      const isSwipe = hasSwiped && Math.abs(deltaX) > 32 && Math.abs(deltaX) > Math.abs(deltaY) * 1.1;

      if (isSwipe) {
        const direction = deltaX < 0 ? 'next' : 'previous';

        event.preventDefault();
        root.dataset.landing1BundleSuppressClick = 'true';
        setBundleGroupWithMotion(root, getAdjacentBundleGroup(root, direction), direction);
        scheduleBundleAutoShuffle(root);
      }

      if (
        typeof swipeTarget.releasePointerCapture === 'function' &&
        (!swipeTarget.hasPointerCapture || swipeTarget.hasPointerCapture(event.pointerId))
      ) {
        swipeTarget.releasePointerCapture(event.pointerId);
      }

      clearSwipe();
    });

    swipeTarget.addEventListener('pointercancel', (event) => {
      if (
        typeof swipeTarget.releasePointerCapture === 'function' &&
        pointerId === event.pointerId &&
        (!swipeTarget.hasPointerCapture || swipeTarget.hasPointerCapture(event.pointerId))
      ) {
        swipeTarget.releasePointerCapture(event.pointerId);
      }

      clearSwipe();
    });
  };

  const bindStickyVisibility = (root) => {
    const landing = getLandingRoot(root);
    const sticky = getStickyCta(root);
    const hero = landing.querySelector('.lx-landing-1-section--hero');
    const included = landing.querySelector('.lx-landing-1-section--included');

    if (!sticky || !hero || sticky.dataset.landing1StickyBound === 'true') return;

    sticky.dataset.landing1StickyBound = 'true';

    const stickySubmit = sticky.querySelector('[data-landing-1-sticky-submit]');

    const setVisible = (isVisible) => {
      sticky.classList.toggle('is-visible', isVisible);
      sticky.setAttribute('aria-hidden', String(!isVisible));

      if (stickySubmit) {
        if (isVisible) {
          stickySubmit.removeAttribute('tabindex');
        } else {
          stickySubmit.setAttribute('tabindex', '-1');
        }
      }
    };

    const updateVisibility = () => {
      const heroRect = hero.getBoundingClientRect();
      const revealLine = window.innerHeight * 0.7;
      const scrollDepthTrigger = Math.min(hero.offsetHeight * 0.3, window.innerHeight * 0.45);
      const includedIsEntering = included ? included.getBoundingClientRect().top <= window.innerHeight * 0.75 : false;

      setVisible(includedIsEntering || heroRect.bottom <= revealLine || heroRect.top <= -scrollDepthTrigger);
    };

    if ('IntersectionObserver' in window) {
      const observer = new IntersectionObserver(updateVisibility, { threshold: 0 });
      observer.observe(hero);
      sticky.landing1StickyObserver = observer;
    }

    if ('ResizeObserver' in window) {
      const resizeObserver = new ResizeObserver(() => fitStickyPrice(sticky));
      resizeObserver.observe(sticky);
      sticky.landing1StickyResizeObserver = resizeObserver;
    }

    window.addEventListener('scroll', updateVisibility, { passive: true });
    window.addEventListener('resize', updateVisibility);
    window.addEventListener('resize', () => fitStickyPrice(sticky));

    if (document.fonts && typeof document.fonts.ready === 'object') {
      document.fonts.ready.then(() => fitStickyPrice(sticky)).catch(() => {});
    }

    updateVisibility();
    fitStickyPrice(sticky);
  };

  const getLandingHeroes = (scope) => {
    const searchScope = scope || document;

    if (searchScope.matches && searchScope.matches('.lx-landing-1-hero')) return [searchScope];

    return Array.from(searchScope.querySelectorAll('.lx-landing-1-hero'));
  };

  const bindHeroMediaScroll = (scope) => {
    getLandingHeroes(scope).forEach((hero) => {
      if (
        hero.dataset.landing1HeroMediaBound === 'true' ||
        hero.closest('.lumenearz-style-guide__landing-1-preview')
      ) {
        return;
      }

      let isQueued = false;
      const updateOpacity = () => {
        const rect = hero.getBoundingClientRect();
        const fadeDistance = Math.max(1, Math.min(window.innerHeight * 0.52, hero.offsetHeight * 0.46));
        const fadeProgress = Math.min(1, Math.max(0, -rect.top / fadeDistance));
        const opacity = Math.max(0, 1 - fadeProgress);

        hero.style.setProperty('--lx-landing-1-hero-media-opacity', opacity.toFixed(3));
      };
      const requestUpdate = () => {
        if (isQueued) return;

        isQueued = true;
        window.requestAnimationFrame(() => {
          isQueued = false;
          updateOpacity();
        });
      };

      hero.dataset.landing1HeroMediaBound = 'true';
      window.addEventListener('scroll', requestUpdate, { passive: true });
      window.addEventListener('resize', requestUpdate);
      updateOpacity();
    });
  };

  const handleBundleAdd = (root, triggerButton) => {
    const submit = triggerButton || root.querySelector('[data-landing-1-bundle-submit]');
    const message = root.querySelector('[data-landing-1-bundle-message]');
    const activeGroup = root.dataset.activeGroup || 'shades';
    const activeItem = getGroupElements(root, '[data-landing-1-bundle-item]', activeGroup).find((item) =>
      item.classList.contains('is-active')
    );
    const baseVariantId = Number.parseInt(root.dataset.baseVariantId, 10);
    const partnerVariantId = activeItem ? Number.parseInt(activeItem.dataset.variantId, 10) : Number.NaN;
    const cart = getCartTarget();
    const isLoading = getSubmitButtons(root).some((button) => button.classList.contains('is-loading'));

    if (!submit || submit.disabled || isLoading) return;

    if (!baseVariantId || !partnerVariantId) {
      if (message) {
        message.textContent = root.dataset.unavailableLabel || 'Unavailable';
        message.hidden = false;
      }
      updateBundleSubmit(root, activeItem);
      return;
    }

    if (message) {
      message.hidden = true;
      message.textContent = '';
    }

    setBundleLoading(root, true);

    const payload = {
      items: [
        { id: baseVariantId, quantity: 1 },
        { id: partnerVariantId, quantity: 1 },
      ],
    };

    if (cart && typeof cart.getSectionsToRender === 'function') {
      payload.sections = cart.getSectionsToRender().map((section) => section.id);
      payload.sections_url = window.location.pathname;

      if (typeof cart.setActiveElement === 'function') {
        cart.setActiveElement(document.activeElement);
      }
    }

    const config = window.fetchConfig
      ? window.fetchConfig('javascript')
      : {
          method: 'POST',
          headers: {
            Accept: 'application/json',
            'Content-Type': 'application/json',
          },
        };

    config.headers = config.headers || {};
    config.headers['Content-Type'] = 'application/json';
    config.headers['X-Requested-With'] = 'XMLHttpRequest';
    config.body = JSON.stringify(payload);

    fetch(getCartAddUrl(), config)
      .then((response) =>
        response.json().then((parsedState) => {
          if (!response.ok || parsedState.status) throw parsedState;
          return parsedState;
        })
      )
      .then((parsedState) => {
        const firstItem = parsedState.items && parsedState.items[0] ? parsedState.items[0] : null;

        if (firstItem) {
          parsedState.key = firstItem.key;
          parsedState.id = firstItem.id;
        }

        if (window.publish && window.PUB_SUB_EVENTS) {
          window.publish(window.PUB_SUB_EVENTS.cartUpdate, {
            source: 'lumenearz-landing-1-bundle',
            productVariantId: partnerVariantId,
            cartData: parsedState,
          });
        }

        if (cart && typeof cart.renderContents === 'function' && parsedState.sections) {
          if (
            cart.tagName &&
            cart.tagName.toLowerCase() === 'cart-notification' &&
            cart.header &&
            typeof cart.header.reveal !== 'function'
          ) {
            cart.header = null;
          }

          cart.renderContents(parsedState);
          if (cart.classList && cart.classList.contains('is-empty')) cart.classList.remove('is-empty');
        } else {
          window.location = getCartUrl();
        }
      })
      .catch((error) => {
        if (message) {
          message.textContent = error.description || error.message || 'Unable to add this bundle right now.';
          message.hidden = false;
        }
      })
      .finally(() => {
        setBundleLoading(root, false);
        updateBundleSubmit(root, activeItem);
      });
  };

  const reviewModalOpenClass = 'lx-product-reviews-modal-open';

  const getLandingReviewRoots = (scope) => {
    const searchScope = scope || document;

    if (searchScope.matches && searchScope.matches('.lx-landing-1-testimonials[data-product-reviews]')) {
      return [searchScope];
    }

    return Array.from(searchScope.querySelectorAll('.lx-landing-1-testimonials[data-product-reviews]'));
  };

  const getLandingReviewModal = (root) =>
    root.landing1ReviewModal ||
    root.productReviewModal ||
    root.querySelector('[data-product-review-modal]') ||
    document.querySelector('.lx-landing-1-testimonials-modal');

  const getReviewFocusableElements = (root) =>
    Array.from(root.querySelectorAll('a[href], button:not([disabled]), textarea, input, select, video[controls], iframe, [tabindex]:not([tabindex="-1"])'));

  const closeLandingReviewModal = (root) => {
    const modal = getLandingReviewModal(root);
    const content = modal ? modal.querySelector('[data-product-review-modal-content]') : null;

    if (!modal || modal.hidden) return;

    modal.hidden = true;
    document.documentElement.classList.remove(reviewModalOpenClass);
    document.body.classList.remove(reviewModalOpenClass);

    if (content) content.innerHTML = '';

    if (root.landing1ReviewLastFocused && root.landing1ReviewLastFocused.focus) {
      root.landing1ReviewLastFocused.focus({ preventScroll: true });
    }

    root.landing1ReviewLastFocused = null;
  };

  const bindLandingReviewModal = (root) => {
    const modal = getLandingReviewModal(root);

    if (!modal || modal.dataset.landing1ReviewModalBound === 'true') return;

    modal.dataset.landing1ReviewModalBound = 'true';
    root.landing1ReviewModal = modal;

    if (modal.parentElement !== document.body) {
      document.body.appendChild(modal);
    }

    modal.querySelectorAll('[data-product-review-modal-close]').forEach((button) => {
      button.addEventListener('click', () => closeLandingReviewModal(root));
    });

    modal.addEventListener('keydown', (event) => {
      const focusable = getReviewFocusableElements(modal).filter(
        (element) => element.offsetParent !== null || element === document.activeElement
      );
      const first = focusable[0];
      const last = focusable[focusable.length - 1];

      if (event.key === 'Escape') {
        event.preventDefault();
        closeLandingReviewModal(root);
        return;
      }

      if (event.key !== 'Tab' || !first || !last) return;

      if (event.shiftKey && document.activeElement === first) {
        event.preventDefault();
        last.focus();
      } else if (!event.shiftKey && document.activeElement === last) {
        event.preventDefault();
        first.focus();
      }
    });
  };

  const openLandingReviewModal = (root, card) => {
    const modal = getLandingReviewModal(root);
    const dialog = modal ? modal.querySelector('.lx-product-reviews-modal__dialog') : null;
    const content = modal ? modal.querySelector('[data-product-review-modal-content]') : null;
    const template = card.querySelector('[data-product-review-modal-template]');

    if (!modal || !dialog || !content || !template) return;

    bindLandingReviewModal(root);
    content.innerHTML = '';
    content.appendChild(template.content.cloneNode(true));
    root.landing1ReviewLastFocused = document.activeElement;
    modal.hidden = false;
    document.documentElement.classList.add(reviewModalOpenClass);
    document.body.classList.add(reviewModalOpenClass);
    dialog.focus({ preventScroll: true });
  };

  const bindLandingReviewTrackDrag = (root) => {
    Array.from(root.querySelectorAll('[data-product-review-track]')).forEach((track) => {
      if (track.dataset.productReviewDragBound === 'true' || track.dataset.landing1ReviewDragBound === 'true') return;

      let pointerId = null;
      let startX = 0;
      let startY = 0;
      let startScrollLeft = 0;
      let isDragging = false;
      let suppressTimer = null;

      const stopDrag = () => {
        if (pointerId !== null && track.hasPointerCapture && track.hasPointerCapture(pointerId)) {
          track.releasePointerCapture(pointerId);
        }

        if (isDragging) {
          root.dataset.landing1ReviewSuppressClick = 'true';
          window.clearTimeout(suppressTimer);
          suppressTimer = window.setTimeout(() => {
            delete root.dataset.landing1ReviewSuppressClick;
          }, 350);
        }

        pointerId = null;
        isDragging = false;
        track.classList.remove('is-dragging');
      };

      track.dataset.landing1ReviewDragBound = 'true';

      track.addEventListener('dragstart', (event) => event.preventDefault());

      track.addEventListener('pointerdown', (event) => {
        if (event.pointerType === 'touch' || event.button !== 0 || track.scrollWidth <= track.clientWidth) return;

        pointerId = event.pointerId;
        startX = event.clientX;
        startY = event.clientY;
        startScrollLeft = track.scrollLeft;
        isDragging = false;

        if (track.setPointerCapture) {
          track.setPointerCapture(pointerId);
        }
      });

      track.addEventListener('pointermove', (event) => {
        if (pointerId !== event.pointerId) return;

        const deltaX = event.clientX - startX;
        const deltaY = event.clientY - startY;

        if (!isDragging) {
          if (Math.abs(deltaX) < 6 && Math.abs(deltaY) < 6) return;

          if (Math.abs(deltaY) > Math.abs(deltaX) * 1.25) {
            stopDrag();
            return;
          }

          isDragging = true;
          track.classList.add('is-dragging');
        }

        event.preventDefault();
        track.scrollLeft = startScrollLeft - deltaX;
      });

      track.addEventListener('pointerup', stopDrag);
      track.addEventListener('pointercancel', stopDrag);
    });
  };

  const initLandingReviews = (scope) => {
    getLandingReviewRoots(scope).forEach((root) => {
      if (root.dataset.landing1ReviewsBound === 'true') return;

      root.dataset.landing1ReviewsBound = 'true';
      bindLandingReviewModal(root);
      bindLandingReviewTrackDrag(root);

      Array.from(root.querySelectorAll('[data-product-review-card]')).forEach((card) => {
        card.addEventListener('click', (event) => {
          window.setTimeout(() => {
            const modal = getLandingReviewModal(root);

            if ((modal && !modal.hidden) || root.dataset.landing1ReviewSuppressClick === 'true') return;

            event.preventDefault();
            openLandingReviewModal(root, card);
          }, 0);
        });
      });
    });
  };

  const initLanding1 = () => {
    const bundleRoots = Array.from(document.querySelectorAll('[data-landing-1-bundle]'));

    if (!bundleRoots.length) {
      if (initAttempts < 20) {
        initAttempts += 1;
        window.setTimeout(initLanding1, 100);
      }

      return;
    }

    bundleRoots.forEach((root) => {
      if (root.dataset.landing1BundleBound === 'true') return;

      root.dataset.landing1BundleBound = 'true';

      Array.from(root.querySelectorAll('[data-landing-1-bundle-group]')).forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (consumeSuppressedClick(root)) return;

          setBundleGroupWithMotion(root, button.dataset.bundleGroup, getBundleGroupDirection(root, button.dataset.bundleGroup));
          scheduleBundleAutoShuffle(root);
        });
      });

      Array.from(root.querySelectorAll('[data-landing-1-bundle-arrow]')).forEach((button) => {
        button.addEventListener('click', (event) => {
          const direction = button.dataset.landing1BundleArrow === 'previous' ? 'previous' : 'next';

          event.preventDefault();
          event.stopPropagation();

          if (consumeSuppressedClick(root)) return;

          setBundleGroupWithMotion(root, getAdjacentBundleGroup(root, direction), direction);
          scheduleBundleAutoShuffle(root);
        });
      });

      Array.from(root.querySelectorAll('[data-landing-1-bundle-item]')).forEach((button) => {
        button.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (consumeSuppressedClick(root)) return;

          activateBundleItem(root, button);
          scheduleBundleAutoShuffle(root);
        });
      });

      const submitButton = root.querySelector('[data-landing-1-bundle-submit]');

      if (submitButton) {
        submitButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (consumeSuppressedClick(root)) return;

          handleBundleAdd(root, submitButton);
        });
      }

      const stickySubmitButton = getStickyCta(root)
        ? getStickyCta(root).querySelector('[data-landing-1-sticky-submit]')
        : null;

      if (stickySubmitButton) {
        stickySubmitButton.addEventListener('click', (event) => {
          event.preventDefault();
          event.stopPropagation();

          if (consumeSuppressedClick(root)) return;

          handleBundleAdd(root, stickySubmitButton);
        });
      }

      root.addEventListener('click', (event) => {
        if (consumeSuppressedClick(root)) {
          event.preventDefault();
          event.stopPropagation();
          return;
        }

        const groupButton = event.target.closest('[data-landing-1-bundle-group]');
        const arrowButton = event.target.closest('[data-landing-1-bundle-arrow]');
        const itemButton = event.target.closest('[data-landing-1-bundle-item]');
        const submitButton = event.target.closest('[data-landing-1-bundle-submit]');

        if (groupButton && root.contains(groupButton)) {
          setBundleGroupWithMotion(root, groupButton.dataset.bundleGroup, getBundleGroupDirection(root, groupButton.dataset.bundleGroup));
          scheduleBundleAutoShuffle(root);
          return;
        }

        if (arrowButton && root.contains(arrowButton)) {
          const direction = arrowButton.dataset.landing1BundleArrow === 'previous' ? 'previous' : 'next';

          setBundleGroupWithMotion(root, getAdjacentBundleGroup(root, direction), direction);
          scheduleBundleAutoShuffle(root);
          return;
        }

        if (itemButton && root.contains(itemButton)) {
          activateBundleItem(root, itemButton);
          scheduleBundleAutoShuffle(root);
          return;
        }

        if (submitButton && root.contains(submitButton)) {
          handleBundleAdd(root, submitButton);
        }
      });

      bindBundleSwipe(root);
      bindStickyVisibility(root);
      setBundleGroup(root, root.dataset.activeGroup || 'shades');
      scheduleBundleAutoShuffle(root);
    });

    window.lumenearzLanding1Initialized = bundleRoots.length;
  };

  const initLanding1Page = (event) => {
    const scope = event && event.target ? event.target : document;

    bindHeroMediaScroll(scope);
    initLandingReviews(scope);
    initLanding1();
  };

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', initLanding1Page, { once: true });
  } else {
    initLanding1Page();
  }

  document.addEventListener('shopify:section:load', initLanding1Page);
})();
